'use client'

import { useEffect, useState } from 'react'

type Props = {
  effectiveDate: string
  expiresOnIso: string
}

const STORAGE_KEY = 'ps_privacy_banner_dismissed_v2026-04-25'

export default function PolicyUpdateBanner({ effectiveDate, expiresOnIso }: Props) {
  const [visible, setVisible] = useState(false)

  useEffect(() => {
    if (Date.now() > new Date(expiresOnIso).getTime()) {
      return
    }
    try {
      if (window.localStorage.getItem(STORAGE_KEY) === '1') {
        return
      }
    } catch {
      // localStorage unavailable (private mode); still show the banner.
    }
    setVisible(true)
  }, [expiresOnIso])

  if (!visible) return null

  const dismiss = () => {
    try {
      window.localStorage.setItem(STORAGE_KEY, '1')
    } catch {
      // no-op
    }
    setVisible(false)
  }

  return (
    <div className="border-b border-terra-500/30 bg-terra-50/60">
      <div className="editorial py-3 flex flex-col sm:flex-row sm:items-center gap-3 sm:gap-6">
        <p className="text-body-sm text-ink-800 leading-relaxed flex-1">
          <span className="font-semibold text-ink-900">Policy updated {effectiveDate}.</span>{' '}
          This policy was revised to reflect new data modules covering IP filings,
          litigation, regulatory presence, customer logos, and related public-registry
          sources, plus per-user digest and alert delivery introduced in the intelligence layer.
        </p>
        <button
          type="button"
          onClick={dismiss}
          className="self-start sm:self-auto rounded-full border border-ink-900/15 bg-cream-50 px-3 py-1.5 mono text-caption uppercase tracking-widest text-ink-700 hover:border-ink-900/30 transition-colors whitespace-nowrap"
        >
          Dismiss
        </button>
      </div>
    </div>
  )
}
